import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";

import { AuxiaResponse } from "../auxia/get-auxia-jsm-paid-lp-treatment";

import { JiraSoftwarePagePaidLpJsmAnchor } from "./paid-lp-jsm-anchor";
export interface JiraSoftwarePagePaidLpJsmAssetProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
    auxiaResponse?: AuxiaResponse | null;
}

export const JiraServiceManagementSoftwarePageAnchorLpJsmAsset = (
    pageProps: JiraSoftwarePagePaidLpJsmAssetProps
) => {
    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );

    return (
        <JiraSoftwarePagePaidLpJsmAnchor
            {...pageProps}
            anchorContents={shapeAnchorContentfulResponse(data)}
            pageId="anchor-lp-jsm-asset"
            persona="unknown"
            pageVariant="asset"
            auxiaResponse={pageProps.auxiaResponse}
        />
    );
};
